/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-16 11:13:53
 */ 
export const specimenEn = {
    xunjiadang:'Sample management',
    zhengshuzhuantai:'Sample status',
    qingxuanzhe:'Please select sample status',
    kehujigei:'Customer to platform',
    pingtaiyishoudao:'Platform received',
    pingtaijihui:'Platform send back to customer',
    kehushoudao:'Customer receives the returned sample',
    xiaohui:'Destruction',
    kaishishijian:'start time',
    jieshushijian:'End time',
    sousuo:'search',
    dingdangbianhao:'Order number',
    xuhao:'Serial number',
    yangpingmingcheng:'Sample name',
    yangpingshuliang:'Sample quantity',
    dingdangbianhao:'Order number',
    wuliouleixing:'Logistics type',
    wulioudanghao:'Logistics number',
    jisongleixing:'Sending type',
    yangpingzuantai:'Sample status',
    chuangjianshijian:'Creation time',
    caozuo:'operation',
    pingtaijigeikehu:'The platform is sent to customers',
}


// WEBPACK FOOTER //
// ./src/lang/member/specimen/specimenEn.js